var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 55,
    viewBox: "0 0 33 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0C1.11926 0 0 1.11926 0 2.5V38.5C0 47.6127 7.38733 55 16.5 55C25.6127 55 33 47.6127 33 38.5C33 29.3873 25.6127 22 16.5 22C12.0282 22 7.9718 23.779 5 26.6678V2.5C5 1.11926 3.88074 0 2.5 0ZM5 38.5C5 44.8513 10.1487 50 16.5 50C22.8513 50 28 44.8513 28 38.5C28 32.1487 22.8513 27 16.5 27C10.1487 27 5 32.1487 5 38.5Z",
    fill: "#20ACF7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeep);
export default __webpack_public_path__ + "static/media/beep.e90b6b43cfb630977b56a1f1674f4e6f.svg";
export { ForwardRef as ReactComponent };